// import React, { useEffect, useState } from 'react'
// import ProgramManagerMasterGrid from './ProgramManagerMasterGrid'
// import api from '../../utils/api'
// import { toast } from 'react-toastify'
// import { ControlledInput } from '../../common/Input/Input'
// import Spinner from '../../common/Spinner/Spinner'

// const ProgramManagerMasterHome = () => {

//     const [programManagerFields, setProgramManagerFields] = useState({
//         sProgramManager: '',
//     })

//     const [tableData, setTableData] = useState([])

//     const [loading, setLoading] = useState(false)

//     const [isEditClicked, setIsEditClicked] = useState(false)
//     const [isAddClicked, setIsAddClicked] = useState(false)

//     useEffect(() => {
//         fetchTableData()
//     }, [])

//     const fetchTableData = () => {
//         setLoading(true)
//         const { tempGetProgramManagerData } = api.getAllProgramManagerData()
//             .then(({ data }) => {
//                 setLoading(false)
//                 setTableData(data)
//             })
//     }

//     const handleChange = (names, value) => {
//         const updated = { ...programManagerFields, [names]: value }
//         setProgramManagerFields(updated)

//         const {
//             sProgramManager,
//         } = updated
//     }

//     const editProgramManager = (ele) => {
//         setProgramManagerFields({
//             name: ele.name,
//             email: ele.email,
//             contact: ele.contact
//         })
//         setIsEditClicked(true)
//     }

//     const addProgramManager = () => {
//         setIsAddClicked(!isAddClicked)
//     }

//     const onEditBackClick = () => {
//         setIsEditClicked(false)
//         setProgramManagerFields({
//             name: "",
//             email: "",
//             contact: ""
//         })
//     }

//     const onAddBackClick = () => {
//         setIsAddClicked(false)
//         setProgramManagerFields({
//             sProgramManager: "",
//         })
//     }

//     const onAddSaveBtnClick = () => {
//         if (!programManagerFields.sProgramManager) {
//             toast("Program manager is Required.", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else {
//             let payload = {
//                 sProgramManager: programManagerFields.sProgramManager
//             }
//             setLoading(true)
//             const { tempAddProgramManager } = api.addProgramManager(payload)
//                 .then(({ data }) => {
//                     toast("Added Successfully.", {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     })
//                     setLoading(false)
//                     setIsAddClicked(false)
//                     fetchTableData()

//                 })
//                 .catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         }
//     }

//     return (
//         <div className={`${loading && "set-opacity"}`}>
//             {loading && <Spinner className="center-screen" />}
//             <div className="row mt-3">
//                 <div className="col-6"
//                     style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between' }}
//                 >
//                     <label>
//                         <b>Program Manager List</b>
//                     </label>

//                     <button className="my-services-model-submit-btn"
//                         onClick={() => addProgramManager()}
//                     >Add Program Manager</button>
//                 </div>
//             </div>

//             {
//                 isAddClicked &&
//                 <div>
//                     <label>
//                         <b>Add Program Manager</b>
//                     </label>

//                     <div className="row mt-1">
//                         <div className="col-4">
//                             <label style={{ marginBottom: "5px" }}>Program Manager Name <span className="required">*</span></label><br />
//                             <ControlledInput
//                                 name="sProgramManager"
//                                 placeholder="Program Manager Name"
//                                 value={programManagerFields.sProgramManager || ""}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 onKeyDown={(event) => {
//                                     if (event.key >= '0' && event.key <= '9') {
//                                         event.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div>

//                         <div className="col-4 d-flex align-items-center" style={{ marginTop: '12px' }}>
//                             <button className='my-services-model-submit-btn' onClick={onAddSaveBtnClick} > Save</button>
//                         </div>

//                     </div>
//                 </div>
//             }

//             <div className="row mt-3">
//                 <div className="col-6">
//                     <ProgramManagerMasterGrid editProgramManager={editProgramManager} tableData={tableData} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default ProgramManagerMasterHome



import React, { useEffect, useState } from 'react'
import ProgramManagerMasterGrid from './ProgramManagerMasterGrid'
import api from '../../utils/api'
import { toast } from 'react-toastify'
import { ControlledInput } from '../../common/Input/Input'
import Spinner from '../../common/Spinner/Spinner'

const ProgramManagerMasterHome = () => {

    const [programManagerFields, setProgramManagerFields] = useState({
        sProgramManager: '',
    })

    const [tableData, setTableData] = useState([])

    const [loading, setLoading] = useState(false)

    const [isEditClicked, setIsEditClicked] = useState(false)
    const [isAddClicked, setIsAddClicked] = useState(false)

    useEffect(() => {
        fetchTableData()
    }, [])

    const fetchTableData = () => {
        setLoading(true)
        const { tempGetProgramManagerData } = api.getAllProgramManagerData()
            .then(({ data }) => {
                setLoading(false)
                data.sort((a, b) => {
                  // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
                  const entryA = a.sProgramManager.toLowerCase();
                  const entryB = b.sProgramManager.toLowerCase();
              
                  // Compare the two `sEntryPoint` values
                  if (entryA < entryB) return -1;
                  if (entryA > entryB) return 1;
                  return 0;
                });
                setTableData(data)
            })
    }

    const handleChange = (names, value) => {
        const updated = { ...programManagerFields, [names]: value }
        setProgramManagerFields(updated)

        const {
            sProgramManager,
        } = updated
    }

    const editProgramManager = (ele) => {
        setProgramManagerFields({
            name: ele.name,
            email: ele.email,
            contact: ele.contact
        })
        setIsEditClicked(true)
    }

    const addProgramManager = () => {
        setIsAddClicked(!isAddClicked)
    }

    const onEditBackClick = () => {
        setIsEditClicked(false)
        setProgramManagerFields({
            name: "",
            email: "",
            contact: ""
        })
    }

    const onAddBackClick = () => {
        setIsAddClicked(false)
        setProgramManagerFields({
            sProgramManager: "",
        })
    }

    const onAddSaveBtnClick = () => {
        const {sProgramManager} = programManagerFields
        const trimmedProgrammeManager = sProgramManager.trim();


        if (!trimmedProgrammeManager) {
            toast("Program manager is Required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else {
            let payload = {
                sProgramManager: trimmedProgrammeManager
            }
            setLoading(true)
            const { tempAddProgramManager } = api.addProgramManager(payload)
                .then(({ data }) => {
                    toast("Added Successfully.", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    })
                    setLoading(false)
                    setIsAddClicked(false)
                    fetchTableData()

                    setProgramManagerFields({
                        sProgramManager: '',
                    })


                })
                .catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        setLoading(false)
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        setLoading(false)
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        }
    }

    return (
        <div className={`${loading && "set-opacity"}`}>
            {loading && <Spinner className="center-screen" />}
            <div className="row mt-3">
                {/* Header row for the label */}
                {/* <div className="col-12 text-center mb-2">
                    <div className='col-6'>
                        <label>
                            <b>Program Manager List</b>
                        </label>
                    </div>
                </div> */}

                {/* Row for buttons and search bar */}
                <div className="col-6" style={{
                    display: "flex",
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    backgroundColor: "",
                    padding: "10px",
                    borderRadius: "8px"
                }}>
                    {/* Left Section: Add Partner and Download Buttons */}
                    <label>
                            <b>Program Manager List</b>
                    </label>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "",
                        paddingRight: '10px',
                        paddingLeft:"8px"
                    }}>
                        <button className="my-services-model-submit-btn"
                        onClick={() => addProgramManager()}
                        >Add Program Manager</button>
                    </div>
                </div>

            </div>

            {
                isAddClicked &&
                <div>
                    <label>
                        <b>Add Program Manager</b>
                    </label>

                    <div className="row mt-1">
                        <div className="col-4">
                            <label style={{ marginBottom: "5px" }}>Program Manager Name <span className="required">*</span></label><br />
                            <ControlledInput
                                name="sProgramManager"
                                placeholder="Program Manager Name"
                                value={programManagerFields.sProgramManager || ""}
                                onChange={({ target: { name, value } }) => handleChange(name, value)}
                                onKeyDown={(event) => {
                                    if (event.key >= '0' && event.key <= '9') {
                                        event.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div>

                        <div className="col-4 d-flex align-items-center" style={{ marginTop: '12px' }}>
                            <button className='my-services-model-submit-btn' onClick={onAddSaveBtnClick} > Save</button>
                        </div>

                    </div>
                </div>
            }

            <div className="row mt-3">
                <div className="col-6">
                    <ProgramManagerMasterGrid editProgramManager={editProgramManager} tableData={tableData} />
                </div>
            </div>
        </div>
    )
}

export default ProgramManagerMasterHome

